import React from "react";
import { Input } from "../../components/ui/input";
import { Textarea } from "../../components/ui/textarea";

export const SLIDE_LABELS = {
  s1: "01 · Capa", s2: "02 · O que vemos nas empresas", s3: "03 · O que fazemos",
  s4: "04 · Como pensamos", s5: "05 · Capacidades", s6: "06 · STRATFLOW",
  s7: "07 · HandOff Mapping", s8: "08 · Gestão e execução", s9: "09 · Tecnologia",
  s10: "10 · IA aplicada", s11: "11 · Experiência", s12: "12 · Pontos de partida",
  s13: "13 · Mercados e contextos", s14: "14 · Encerramento",
};

export const LABELS = {
  title: "Título", title2: "Título (linha 2)", sub: "Subtítulo", closing: "Frase de fechamento",
  text: "Texto", label: "Rótulo", slogan: "Slogan", items: "Itens", questions: "Perguntas",
  steps: "Etapas", cols: "Colunas", rows: "Linhas", t: "Texto", c: "Células", note: "Nota",
  center: "Centro do diagrama", dims: "Dimensões", map_label: "Título da lista", map: "Lista de mapeamento",
  reveal_label: "Título das revelações", reveals: "Revelações", gains: "Rótulos de ganho",
  before: "Antes", after: "Depois", markets_label: "Título de mercados", markets: "Mercados",
  contexts_label: "Título de contextos", contexts: "Contextos",
  e: "Eficiência", q: "Qualidade", d: "Decisão", s: "Escala",
};

export const setPath = (obj, path, value) => {
  const parts = path.split(".");
  let cur = obj;
  for (const p of parts.slice(0, -1)) cur = cur[p];
  cur[parts[parts.length - 1]] = value;
};

function walkChanges(a, b, path, out) {
  if (typeof a === "string" || typeof b === "string") {
    if (a !== b) out.push(path);
    return;
  }
  if (Array.isArray(a) && Array.isArray(b)) {
    a.forEach((v, i) => walkChanges(v, b[i], path ? `${path}.${i}` : String(i), out));
    return;
  }
  if (a && b && typeof a === "object") {
    Object.keys(a).forEach((k) => walkChanges(a[k], b[k], path ? `${path}.${k}` : k, out));
  }
}

export const collectChanges = (a, b) => {
  const out = [];
  walkChanges(a, b, "", out);
  return out;
};

function walkFields(value, path, label, out) {
  if (typeof value === "string") {
    out.push({ path, label, value });
    return;
  }
  if (Array.isArray(value)) {
    value.forEach((v, i) => walkFields(v, `${path}.${i}`, `${label} ${i + 1}`, out));
    return;
  }
  if (value && typeof value === "object") {
    Object.entries(value).forEach(([k, v]) => {
      if (k === "g") return;
      walkFields(v, `${path}.${k}`, LABELS[k] || k, out);
    });
  }
}

export const flattenFields = (value, basePath) => {
  const out = [];
  walkFields(value, basePath, basePath, out);
  return out;
};

export const FieldList = ({ fields, onEdit }) => (
  <>
    {fields.map((f) => {
      const long = f.value.length > 70;
      const Comp = long ? Textarea : Input;
      return (
        <div key={f.path} className="space-y-1">
          <label className="text-[0.65rem] font-semibold uppercase tracking-[0.12em] text-[#B8AA98]">{f.label}</label>
          <Comp
            value={f.value}
            rows={long ? Math.min(5, Math.ceil(f.value.length / 60)) : undefined}
            onChange={(e) => onEdit(f.path, e.target.value)}
            data-testid={`editor-field-${f.path}`}
            className="bg-white/70 border-[#D8D1C6] text-[#222] text-sm"
          />
        </div>
      );
    })}
  </>
);
